import { render, staticRenderFns } from "./EmailDragDrop.vue?vue&type=template&id=d95222d8&scoped=true"
import script from "./EmailDragDrop.vue?vue&type=script&lang=js"
export * from "./EmailDragDrop.vue?vue&type=script&lang=js"
import style0 from "./EmailDragDrop.vue?vue&type=style&index=0&id=d95222d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d95222d8",
  null
  
)

export default component.exports